import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  IconButton,
  Divider,
  TextField,
  Box,
} from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ImageIcon from "@mui/icons-material/Image";
import ClearIcon from '@mui/icons-material/Clear';
import styles from '../styles/PromotionalBanner.module.css';

const dummyBanners = [
  {
    id: 1,
    banner_image: "https://main.d34z81njze67ob.amplifyapp.com/assets/image20-XrTLnkBg.png",
    title: "Big Sale!",
    subheading: "Up to 50% off on selected items",
    cta_text: "Shop Sale",
    status: "enabled",
    image_alt_text: "Promotional Banner 1"
  },
  {
    id: 2,
    banner_image: "https://main.d34z81njze67ob.amplifyapp.com/assets/image18.png",
    title: "New Arrivals!",
    subheading: "Check out our latest collection",
    cta_text: "Explore",
    status: "enabled",
    image_alt_text: "Promotional Banner 2"
  },
  {
    id: 3,
    banner_image: "https://main.d34z81njze67ob.amplifyapp.com/assets/image19.png",
    title: "Limited Time Offer!",
    subheading: "Hurry up before it ends",
    cta_text: "Grab Now",
    status: "enabled",
    image_alt_text: "Promotional Banner 3"
  }
];

export default function PromotionalBanner() {
  const [banners, setBanners] = useState(dummyBanners);
  const [editIndex, setEditIndex] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [alertOpen, setAlertOpen] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState('Digital collection');

  const handleEditBanner = (idx) => {
    setFormValues(banners[idx]);
    setEditIndex(idx);
  };

  const handleDeleteBanner = (idx) => {
    setBanners(banners.filter((_, i) => i !== idx));
    if (editIndex === idx) setEditIndex(null);
  };

  const handleFormChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setFormValues((prev) => ({
        ...prev,
        banner_image: imageUrl,
      }));
    }
  };

  const handleBannerSubmit = () => {
    const updated = [...banners];
    updated[editIndex] = { ...formValues };
    setBanners(updated);
    setEditIndex(null);
    setAlertOpen(true);
    setTimeout(() => setAlertOpen(false), 2000);
  };

  const handleClearCollection = () => {
    setSelectedCollection('None');
  };

  return (
    <Accordion defaultExpanded={false}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={styles.promotionalBannerHeader}
      >
        <GridViewIcon style={{ fontSize: 28, color: '#757575', marginRight: 12 }} />
        <span style={{ fontWeight: 500, fontSize: 16, color: '#232323' }}>Promotion Banner</span>
      </AccordionSummary>
      <AccordionDetails>
        {banners.length > 0 ? (
          <div>
            <div style={{ display: 'flex', gap: 24, overflowX: 'auto', marginBottom: 32 }}>
              {banners.map((banner, idx) => (
                <div key={banner.id} className={styles.promotionalBannerCard}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 18, position: 'relative' }}>
                    <img
                      src={banner.banner_image}
                      alt={banner.image_alt_text}
                      style={{ width: 300, height: 80, objectFit: 'cover', borderRadius: 8, background: '#f3f4f6', marginBottom: 6 }}
                    />
                  </div>
                  <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18, marginBottom: 4 }}>{banner.title}</Typography>
                  <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>{banner.subheading}</Typography>
                  <Typography variant="body2" style={{ color: '#6366f1', fontWeight: 500, marginBottom: 8 }}>{banner.cta_text}</Typography>
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 8 }}>
                    <IconButton size="small" onClick={() => handleEditBanner(idx)}>
                      <EditOutlinedIcon style={{ color: '#888' }} />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleDeleteBanner(idx)}>
                      <DeleteOutlinedIcon style={{ color: 'red' }} />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
            {/* Edit Form Section - appears below the row when editing */}
            {editIndex !== null && (
              <div className={styles.promotionalBannerCard} style={{ marginTop: 0 }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 18, position: 'relative' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <img
                      src={formValues.banner_image}
                      alt={formValues.image_alt_text}
                      style={{ width: 500, height: 100, objectFit: 'cover', borderRadius: 8, background: '#f3f4f6', marginBottom: 6, marginRight: 500 }}
                    />
                    <IconButton component="label" style={{ position: 'relative', top: 40, right: 400 }}>
                      <FileUploadOutlinedIcon />
                      <input hidden accept="image/*" type="file" onChange={handleImageUpload} />
                    </IconButton>
                  </div>
                  <div style={{ color: '#888', fontSize: 13, right: 450, position: 'relative' }}>W 500px / H 100px</div>
                </div>
                <div style={{ marginBottom: 18, position: 'relative' }}>
                  <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>Link collection page</div>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <select
                      style={{ flex: 1, padding: '0.7rem 1.1rem', borderRadius: 8, border: '1.5px solid #c7d2fe', fontSize: '1.08rem', marginBottom: 12, background: '#fff', appearance: 'auto' }}
                      value={selectedCollection}
                      onChange={e => setSelectedCollection(e.target.value)}
                    >
                      <option>None</option>
                      <option>Scented Candles</option>
                      <option>Birthday Candles</option>
                      <option>Tea Light Candles</option>
                      <option>Jar Candles</option>
                    </select>
                    {selectedCollection !== 'None' && (
                      <IconButton
                        size="small"
                        onClick={handleClearCollection}
                        style={{ position: 'absolute', right: 32, top: '50%', transform: 'translateY(-50%)', zIndex: 2, padding: 2 }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    )}
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>Url to link collection page</div>
                  <input
                    type="text"
                    value={selectedCollection === 'None' ? '' : 'https://klcreation.com/products?collection_id=540'}
                    disabled
                    style={{ width: '100%', padding: '0.7rem 1.1rem', borderRadius: 8, border: '1.5px solid #c7d2fe', fontSize: '1.08rem', background: '#f8fafc', color: '#888' }}
                    placeholder="No collection selected"
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                  <Button variant="contained" style={{ background: 'rgba(227, 221, 221, 1)', color: '#000',  border: '1.5px solid #000',borderRadius: 8, minWidth: 90 }} onClick={handleBannerSubmit}>SAVE</Button>
                  <Button variant="outlined" style={{  background: 'white', color: 'black',minWidth: 90 ,borderRadius: 8, border: '1.5px solid #000'}} onClick={() => setEditIndex(null)}>CANCEL</Button>
                </div>
                {alertOpen && (
                  <div style={{ marginTop: 18, background: '#d1fae5', color: '#059669', padding: '0.8rem 1.2rem', borderRadius: 8, fontWeight: 600, textAlign: 'center', fontSize: 16 }}>
                    Banner image saved successfully!
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <Box sx={{ mb: 2, color: '#888' }}>No promotional banner set. Please add one.</Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
}